module.exports = "/images/vendor/flag-icon-css/flags/4x3/il.svg?874270d66e9553b21e76dc1d433ba4a9";